import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpClientBase } from "./http-client-base.service";

export interface Flujo {
  id: number;
  idServicioExterno: string;
  nombre: string;
  endpoint: string;
  createdAt: string;
  updatedAt: string;
}

interface ApiResponse<T> {
  item: T[];
}

@Injectable({ providedIn: "root" })
export class FlujoService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, "servicios/externos");
  }

  get headers() {
    return {
      headers: {},
    };
  }

  getFlujos(idServicio, page, limit, search = null, pagination = "true") {
    return this.get<Flujo[]>({
      endpoint: `/${idServicio}/flujos?page=${page}&limit=${limit}&pagination=${pagination}`,
    });
  }
}
